import request from '@/utils/request'

// 会员等级更变记录列表
export const listMemberLevelLog = (pageData, formData) => {
    return request.post(`/memberLevelLog/${pageData.page}/${pageData.pageSize}`, formData)
}

// 统计
export const getMemberLevelLogStatistics = (formData) => {
    return request.post(`/memberLevelLog/statistics`, formData)
}